import { TicketStatus } from '@gb-ticket/shared-types';

function isShortcutClose(from: TicketStatus, to: TicketStatus): boolean {
  return to === TicketStatus.CLOSED && from !== TicketStatus.RESOLVED;
}

/** Primary CTA is the first allowed transition that is not “Gelöst & geschlossen”. */
export function splitTicketTransitions(
  from: TicketStatus,
  allowed: readonly TicketStatus[],
): { primary: TicketStatus | undefined; rest: TicketStatus[] } {
  const primary = allowed.find((status) => !isShortcutClose(from, status)) ?? allowed[0];
  return {
    primary,
    rest: allowed.filter((status) => status !== primary),
  };
}
